export function parseReadableRating(rating: number, ratingCount: number | undefined): string {
    if (ratingCount === 0) return '0.0'

    // Round rating to one decimal if it has a decimal, otherwise show the integer + 0
    if (rating % 1 === 0) {
        return rating + '.0'
    }

    // round to the first decimal
    return rating.toFixed(1).toString()
}
